import { SortOrder } from './../../models';
import {
	CoMaFilterAction,
	CoMaSortAction,
	ContentManagerAction
} from './content-manager.types';
export const COMA_FILTER_CHANGED: string = 'COMA_FILTER_CHANGED';
export const COMA_SORT_CHANGED: string = 'COMA_SORT_CHANGED';
export const COMA_RESET: string = 'COMA_RESET';

export function comaResetStates(): ContentManagerAction {
	return {
		type: COMA_RESET
	};
}

export function comaSetFilter(
	property: string,
	value: string
): CoMaFilterAction {
	return {
		type: COMA_FILTER_CHANGED,
		payload: { property: property, value }
	};
}

export function comaSetSort(
	property: string,
	order: SortOrder
): CoMaSortAction {
	return {
		type: COMA_SORT_CHANGED,
		payload: { property: property, order }
	};
}
